<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="28.094" height="28.094" viewBox="276.867 566.241 28.094 28.094">
        <g data-name="time-svgrepo-com-3">
            <path
                d="M293.467 581.794c1.026-.459 2.302-1.03 2.302-2.69a2.43 2.43 0 0 0-2.427-2.427 2.43 2.43 0 0 0-2.427 2.427.455.455 0 1 0 .91 0c0-.836.68-1.517 1.517-1.517.836 0 1.517.68 1.517 1.517 0 1.018-.67 1.37-1.764 1.86-.971.435-2.18.977-2.18 2.479 0 .251.203.455.455.455h3.944a.455.455 0 1 0 0-.91h-3.418c.19-.546.754-.827 1.571-1.194Z"
                :fill="color || '#fff'"
                fill-rule="evenodd"
                data-name="Path 786"
            />
            <path
                d="m303.519 588.618-1.87.731a13.925 13.925 0 0 0 3.312-9.062c0-3.752-1.461-7.28-4.114-9.932a13.955 13.955 0 0 0-9.933-4.114c-3.752 0-7.28 1.46-9.933 4.114a13.955 13.955 0 0 0-4.114 9.932c0 3.753 1.461 7.28 4.114 9.933a13.955 13.955 0 0 0 9.933 4.114c2.89 0 5.665-.87 8.027-2.518a.455.455 0 0 0-.52-.746 13.057 13.057 0 0 1-7.507 2.354 13.05 13.05 0 0 1-9.289-3.847 13.05 13.05 0 0 1-3.848-9.29 13.05 13.05 0 0 1 3.848-9.289 13.05 13.05 0 0 1 9.29-3.847 13.05 13.05 0 0 1 9.288 3.847 13.05 13.05 0 0 1 3.848 9.29c0 3.254-1.172 6.319-3.316 8.724l.377-2.337a.455.455 0 0 0-.899-.145l-.487 3.025a.93.93 0 0 0 .337.882.932.932 0 0 0 .934.144l2.853-1.116a.455.455 0 0 0-.331-.847Z"
                :fill="color || '#fff'"
                fill-rule="evenodd"
                data-name="Path 787"
            />
            <path
                d="m288.851 575.775-2.912 8.737a.455.455 0 1 0 .863.288l2.913-8.737a.455.455 0 0 0-.864-.288Z"
                :fill="color || '#fff'"
                fill-rule="evenodd"
                data-name="Path 788"
            />
            <path
                d="M282.009 583.843a.452.452 0 0 0 .616-.185l3.398-6.31a.455.455 0 0 0-.4-.67h-3.884a.455.455 0 1 0 0 .91h3.122l-3.037 5.639a.455.455 0 0 0 .185.616Z"
                :fill="color || '#fff'"
                fill-rule="evenodd"
                data-name="Path 789"
            />
            <path
                d="M300.107 583.898a.455.455 0 0 0 .455-.455v-1.001h.516a.455.455 0 1 0 0-.91h-.516v-4.4a.455.455 0 1 0-.91 0v4.4h-2.331l1.28-4.269a.455.455 0 0 0-.871-.262l-1.455 4.849-.001.004v.002l-.003.008a.438.438 0 0 0-.008.034l-.003.022-.004.022a.435.435 0 0 0-.001.036V581.987l.001.041v.005a.474.474 0 0 0 .006.036l.002.01c0 .006.003.011.004.017.013.05.033.096.06.138l.003.006.015.019.012.016.007.008c.031.036.068.067.11.093l.018.01.007.004a.466.466 0 0 0 .034.016l.004.002.04.014h.003c.018.006.036.01.055.013l.015.002a.46.46 0 0 0 .054.004H299.652v1.002c0 .251.204.455.455.455Z"
                :fill="color || '#fff'"
                fill-rule="evenodd"
                data-name="Path 790"
            />
        </g>
    </svg>
</template>

<script>
export default {
    name: "FullTime",
    props: ["color"],
};
</script>

<style scoped></style>
